import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type {
  FieldPath,
  UseFormSetValue,
  UseFormGetValues,
} from 'react-hook-form';
import {
  RelayEnvironmentScope,
  useCherreValue,
} from '@cherre-frontend/data-fetching';
import { type MappingFieldsTableValues } from 'src/products/models-library/schema';
import { $getMappingFields } from '../services/dsp/useGetMappingFields';
import { MappingTableAutocompleteField } from './MappingTableAutocompleteField';

interface MappingLookupTableAutocompleteProps {
  disabled?: boolean;
  fieldName: FieldPath<MappingFieldsTableValues>;
  setMappingValues: UseFormSetValue<MappingFieldsTableValues>;
  getMappingValues: UseFormGetValues<MappingFieldsTableValues>;
}

const MappingLookupTableAutocomplete = ({
  fieldName,
  getMappingValues,
  setMappingValues,
  disabled,
}: MappingLookupTableAutocompleteProps) => {
  const organizationId =
    useSelector((state) => state.user.profile.value.organizationId) ?? -1;
  const getMappingFields = useCherreValue(
    $getMappingFields({
      organizationId,
    })
  );

  const autoCompleteOptions = useMemo(
    () =>
      getMappingFields?.map((template) => ({
        label: template?.mapping_field_description ?? '',
        value: template?.mapping_field_name ?? '',
      })) ?? [],
    [getMappingFields]
  );

  return (
    <MappingTableAutocompleteField
      name={fieldName}
      getMappingValues={getMappingValues}
      setMappingValues={setMappingValues}
      label='Select Lookup Table'
      options={autoCompleteOptions}
      disabled={disabled}
    />
  );
};

const MappingLookupTableAutocompleteWrapper = (
  props: MappingLookupTableAutocompleteProps
) => {
  return (
    <RelayEnvironmentScope environment='view_admin'>
      <MappingLookupTableAutocomplete {...props} />
    </RelayEnvironmentScope>
  );
};

MappingLookupTableAutocompleteWrapper.displayName =
  'MappingLookupTableAutocomplete';
export default MappingLookupTableAutocompleteWrapper;
